const Switchery = require('switchery');

function MakeSwitcheryOnEach() {
  const selects = $('.js-switch');
  if (selects.length) {
    selects.each(function(n, el) {
      new Switchery(el);
    });
  }
}

exports.init = MakeSwitcheryOnEach;
